import type { MermaidConfig } from 'mermaid'

// Tema único de Mermaid con la paleta de Torcaza (neutral de shadcn, ver
// src/styles/globals.css). Se usa en la vista previa de md-editor (main.ts),
// en el visor avanzado y en los editores de diagramas, para que el diagrama se
// vea igual en el documento, el visor y el PDF. Siempre claro: los documentos
// se exportan a PDF y deben verse bien impresos.
const font = 'ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'

export const torcazaMermaidConfig: MermaidConfig = {
  startOnLoad: false,
  theme: 'base',
  fontFamily: font,
  themeVariables: {
    fontFamily: font,
    fontSize: '14px',
    darkMode: false,

    background: '#ffffff',
    // Nodos: blanco con borde neutro y texto casi negro
    primaryColor: '#ffffff',
    primaryTextColor: '#171717',
    primaryBorderColor: '#a3a3a3',
    // Secundario/terciario: grises de la app (secondary/muted)
    secondaryColor: '#f5f5f5',
    secondaryTextColor: '#171717',
    secondaryBorderColor: '#d4d4d4',
    tertiaryColor: '#fafafa',
    tertiaryTextColor: '#171717',
    tertiaryBorderColor: '#e5e5e5',

    lineColor: '#525252',
    textColor: '#171717',
    mainBkg: '#ffffff',
    nodeBorder: '#a3a3a3',
    nodeTextColor: '#171717',
    titleColor: '#0a0a0a',
    edgeLabelBackground: '#ffffff',

    // Subgrafos / grupos
    clusterBkg: '#fafafa',
    clusterBorder: '#d4d4d4',

    // Notas (secuencia, etc.)
    noteBkgColor: '#f5f5f5',
    noteTextColor: '#171717',
    noteBorderColor: '#d4d4d4',

    // Diagramas de secuencia
    actorBkg: '#171717',
    actorBorder: '#171717',
    actorTextColor: '#fafafa',
    actorLineColor: '#a3a3a3',
    signalColor: '#404040',
    signalTextColor: '#171717',
    labelBoxBkgColor: '#f5f5f5',
    labelBoxBorderColor: '#d4d4d4',
    labelTextColor: '#171717',
    loopTextColor: '#171717',
    activationBkgColor: '#f5f5f5',
    activationBorderColor: '#737373',
    sequenceNumberColor: '#fafafa',

    // Gantt / estados / errores
    sectionBkgColor: '#f5f5f5',
    altSectionBkgColor: '#ffffff',
    taskBkgColor: '#262626',
    taskBorderColor: '#171717',
    taskTextColor: '#fafafa',
    taskTextOutsideColor: '#171717',
    activeTaskBkgColor: '#525252',
    activeTaskBorderColor: '#171717',
    doneTaskBkgColor: '#d4d4d4',
    doneTaskBorderColor: '#a3a3a3',
    critBkgColor: '#ef4444',
    critBorderColor: '#b91c1c',
    todayLineColor: '#ef4444',
    gridColor: '#e5e5e5',
    errorBkgColor: '#fef2f2',
    errorTextColor: '#b91c1c',
  },
}
